export const MC_MOCK_NON_PROD_ENVIRONMENTS = ["LOCAL", "DEV", "SIT", "UAT"];

export const isNonProdEnvironment: () => boolean = () => {
  return MC_MOCK_NON_PROD_ENVIRONMENTS.includes(process.env.REACT_APP_ENVIRONMENT as string);
};

export default isNonProdEnvironment;
